<div class="rc-shell">
<div class="container">

    <div *ngIf="tela() === 'lista'">

        <header class="ds-page-header">
            <div class="ds-page-header-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="5" x2="5" y2="19"></line>
                    <circle cx="6.5" cy="6.5" r="2.5"></circle>
                    <circle cx="17.5" cy="17.5" r="2.5"></circle>
                </svg>
            </div>
            <div class="ds-page-header-copy">
                <h1 class="ds-page-title">Regras de Comissão</h1>
                <p class="ds-page-subtitle">Gerencie as regras de comissão cadastradas</p>
            </div>
            <div class="ds-page-actions">
                <button class="btn secondary" (click)="abrirSimulador()" *ngIf="listaDeRegras().length > 0">
                    Simular
                </button>
                <button class="btn primary" (click)="irParaNovaRegra()" *ngIf="listaDeRegras().length > 0">
                    + Nova Regra
                </button>
            </div>
        </header>

        <div class="card" *ngIf="listaDeRegras().length > 0">
            <div class="table-container">
                <table>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Nome da Regra</th>
                        <th>Período</th>
                        <th>Vendedores</th>
                        <th style="text-align:center;">Parâmetros</th>
                        <th style="text-align:center; width:130px;">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of listaDeRegras(); let i = index">
                        <td class="td-index">{{item.cabecalho.codRegra || (i + 1)}}</td>
                        <td><strong>{{item.cabecalho.nome}}</strong></td>
                        <td>
                            {{formatarData(item.cabecalho.dataInicio)}}
                            &nbsp;→&nbsp;
                            {{formatarData(item.cabecalho.dataFim)}}
                        </td>
                        <td class="td-vendedores">
                            <div class="grupos-truncate" [title]="tooltipVendedores(item)">
                                @if (!item.vendedores || item.vendedores.length === 0) {
                                    <span class="text-muted">—</span>
                                } @else {
                                    @for (v of item.vendedores; track $index) {
                                        <span class="badge-vendedor">{{ v.apelido }}</span>
                                    }
                                }
                            </div>
                        </td>
                        <td style="text-align:center;">
                            <span class="badge-grupo">{{item.regras?.length}} parâmetro(s)</span>
                        </td>
                        <td style="text-align:center;">
                            <div class="action-menu-wrapper" (click)="$event.stopPropagation()">
                                <button class="btn-action-trigger"
                                        [ngClass]="{'open': actionMenuAberto() === i}"
                                        (click)="toggleActionMenu(i, $event)"
                                        title="Ações">⋮</button>
                                <div class="action-menu-dropdown" *ngIf="actionMenuAberto() === i">
                                    <div class="action-menu-item" (click)="editarRegra(i); fecharDropdowns()">Editar</div>
                                    <div class="action-menu-divider"></div>
                                    <div class="action-menu-item text-danger" (click)="excluirRegra(i); fecharDropdowns()">🗑 Excluir</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card" *ngIf="listaDeRegras().length === 0">
            <div class="empty-state">
                <p>Nenhuma regra cadastrada ainda.</p>
                <button class="btn primary" (click)="irParaNovaRegra()">+ Criar primeira regra</button>
            </div>
        </div>

    </div>

    <div *ngIf="tela() === 'formulario'">

        <header class="ds-page-header">
            <div class="ds-page-header-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="5" x2="5" y2="19"></line>
                    <circle cx="6.5" cy="6.5" r="2.5"></circle>
                    <circle cx="17.5" cy="17.5" r="2.5"></circle>
                </svg>
            </div>
            <div class="ds-page-header-copy">
                <h1 class="ds-page-title">{{indiceEdicao() >= 0 ? 'Editar Regra' : 'Nova Regra'}}</h1>
                <p class="ds-page-subtitle">Defina o cabeçalho e os parâmetros de comissão</p>
            </div>
            <div class="ds-page-actions">
                <button class="btn secondary" (click)="irParaLista()">← Voltar</button>
            </div>
        </header>

        <div *ngIf="carregando()" class="loading-overlay">
            <app-loading-indicator></app-loading-indicator>
            <span class="loading-text">{{loadingMsg() || 'Carregando...'}}</span>
        </div>

        <div class="card">
            <div class="card-title">Identificação da Regra</div>
            <div class="cabecalho-form">

                <div class="form-field" style="flex:2; min-width:200px;">
                    <label>Nome da Regra *</label>
                    <input type="text"
                           [(ngModel)]="cabecalho().nome"
                           [disabled]="indiceEdicao() >= 0"
                           placeholder="Ex: Comissão Vendedores 2024"
                           maxlength="100"
                           class="input-nome">
                </div>

                <div class="form-field" style="min-width:200px;" (click)="$event.stopPropagation()">
                    <label>Vendedores</label>
                    <div class="multiselect-wrapper vendedor-wrapper">
                        <div class="multiselect-trigger"
                             tabindex="0"
                             [ngClass]="{'open': dropVendedores()}"
                             (click)="toggleDropVendedores($event)">
                            <span class="multiselect-label">{{labelVendedoresSelecionados()}}</span>
                            <span class="arrow">▾</span>
                        </div>
                        <div class="multiselect-dropdown" *ngIf="dropVendedores()">
                            <div class="multiselect-search">
                                <input type="text"
                                       [(ngModel)]="filtroVendedor"
                                       placeholder="🔍 Pesquisar vendedor..."
                                       (click)="$event.stopPropagation()">
                            </div>
                            <div class="multiselect-options">
                                <div class="multiselect-option multiselect-todos"
                                     (click)="toggleTodosVendedores($event)">
                                    <input type="checkbox"
                                           [checked]="todosVendedoresSelecionados()"
                                           (click)="toggleTodosVendedores($event)">
                                    <span>Selecionar todos</span>
                                </div>
                                <div class="multiselect-divider"></div>
                                <div class="multiselect-option"
                                     *ngFor="let v of vendedoresFiltrados()"
                                     (click)="toggleVendedor(v, $event)">
                                    <input type="checkbox"
                                           [checked]="v.selecionado"
                                           (click)="toggleVendedor(v, $event)">
                                    <span>{{v.apelido}}</span>
                                </div>
                                <div class="multiselect-empty" *ngIf="carregandoVendedores()"><app-loading-indicator size="inline"></app-loading-indicator> Carregando...</div>
                                <div class="multiselect-empty"
                                     *ngIf="!carregandoVendedores() && vendedoresFiltrados().length === 0">
                                    Nenhum vendedor encontrado
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-field" style="min-width:140px;">
                    <label>Data Início *</label>
                    <input type="date"
                           [(ngModel)]="cabecalho().dataInicio"
                           [disabled]="indiceEdicao() >= 0"
                           class="input-data">
                </div>

                <div class="form-field" style="min-width:140px;">
                    <label>Data Fim *</label>
                    <input type="date"
                           [(ngModel)]="cabecalho().dataFim"
                           class="input-data">
                </div>

            </div>

            <div class="cabecalho-aviso" *ngIf="!cabecalhoPreenchido()">
                ⚠️ Preencha o nome e as datas para liberar o cadastro de parâmetros.
            </div>
            <div class="cabecalho-ok" *ngIf="indiceEdicao() >= 0">
                🔒 Modo de edição: Apenas os <strong>vendedores</strong> e a <strong>Data Fim</strong> podem ser alterados após a criação da regra.
            </div>
            <div class="cabecalho-ok" *ngIf="cabecalhoPreenchido() && indiceEdicao() < 0">
                ✅ Cabeçalho preenchido — adicione os parâmetros abaixo.
            </div>
        </div>

        <div class="card" [ngClass]="{'card-disabled': !cabecalhoPreenchido()}" *ngIf="indiceEdicao() < 0">

            <div class="card-title">Novo Parâmetro de Comissão</div>

            <div class="card-locked-overlay" *ngIf="!cabecalhoPreenchido()">
                <span>🔒 Preencha o cabeçalho acima para adicionar parâmetros</span>
            </div>

            <div class="regra-form" [ngClass]="{'form-disabled': !cabecalhoPreenchido()}">

                <div class="form-field">
                    <label>Tipo</label>
                    <select [(ngModel)]="novaRegra().tipo" class="select-tipo" (change)="aoMudarTipoParametro()">
                        <option value="">Selecione...</option>
                        <option value="VALOR">Valor</option>
                        <option value="PORCENTAGEM">Porcentagem</option>
                        <option value="FIXA">Fixa</option>
                    </select>
                </div>

                <div class="form-field form-field-sm">
                    <label>Unid.</label>
                    <select [(ngModel)]="novaRegra().unidadeRef" class="select-unidade" disabled>
                        <option value="R$">R$</option>
                        <option value="%">%</option>
                        <option value="FIXA">FIXA</option>
                    </select>
                </div>

                <div class="form-field">
                    <label>Valor referência inicial</label>
                    <div class="input-prefix-wrapper" [ngClass]="{'disabled': novaRegra().tipo === 'FIXA'}">
                        <span class="input-prefix">{{novaRegra().unidadeRef || 'R$'}}</span>
                        <input type="text" appMoneyMask
                               [(ngModel)]="novaRegra().valorRefInicial"
                               class="input-valor"
                               placeholder="0,00"
                               [disabled]="novaRegra().tipo === 'FIXA'">
                    </div>
                </div>

                <div class="form-field">
                    <label>Valor referência final</label>
                    <div class="input-prefix-wrapper" [ngClass]="{'disabled': novaRegra().tipo === 'FIXA'}">
                        <span class="input-prefix">{{novaRegra().unidadeRef || 'R$'}}</span>
                        <input type="text" appMoneyMask
                               [(ngModel)]="novaRegra().valorRefFinal"
                               class="input-valor"
                               placeholder="0,00"
                               [disabled]="novaRegra().tipo === 'FIXA'">
                    </div>
                </div>

                <div class="form-separator">→</div>

                <div class="form-field form-field-sm">
                    <label>Unid.</label>
                    <select [(ngModel)]="novaRegra().unidadeComissao" class="select-unidade" disabled>
                        <option value="R$">R$</option>
                        <option value="%">%</option>
                    </select>
                </div>

                <div class="form-field">
                    <label>Comissão</label>
                    <div class="input-prefix-wrapper">
                        <span class="input-prefix">{{novaRegra().unidadeComissao || 'R$'}}</span>
                        <input type="text" appMoneyMask
                               [(ngModel)]="novaRegra().valorComissao"
                               class="input-valor"
                               placeholder="0,00">
                    </div>
                </div>

                <div class="form-field" style="min-width:180px;" (click)="$event.stopPropagation()">
                    <label>Grupo de Produtos</label>
                    <div class="multiselect-wrapper">
                        <div class="multiselect-trigger"
                             tabindex="0"
                             [ngClass]="{'open': dropGrupos()}"
                             (click)="toggleDropGrupos($event)">
                            <span class="multiselect-label">{{labelGruposSelecionados()}}</span>
                            <span class="arrow">▾</span>
                        </div>
                        <div class="multiselect-dropdown" *ngIf="dropGrupos()">
                            <div class="multiselect-search">
                                <input type="text"
                                       [(ngModel)]="filtroGrupo"
                                       placeholder="Pesquisar grupo..."
                                       (click)="$event.stopPropagation()">
                            </div>
                            <div class="multiselect-options">
                                <div class="multiselect-option multiselect-todos"
                                     (click)="toggleTodosGrupos($event)">
                                    <input type="checkbox"
                                           [checked]="todosGruposSelecionados()"
                                           (click)="toggleTodosGrupos($event)">
                                    <span>Selecionar todos</span>
                                </div>
                                <div class="multiselect-divider"></div>
                                <div class="multiselect-option"
                                     *ngFor="let g of gruposFiltrados()"
                                     (click)="toggleGrupo(g, $event)">
                                    <input type="checkbox"
                                           [checked]="g.selecionado"
                                           (click)="toggleGrupo(g, $event)">
                                    <span>{{g.descricao}}</span>
                                </div>
                                <div class="multiselect-empty" *ngIf="carregandoGrupos()"><app-loading-indicator size="inline"></app-loading-indicator> Carregando...</div>
                                <div class="multiselect-empty"
                                     *ngIf="!carregandoGrupos() && gruposFiltrados().length === 0">
                                    Nenhum grupo encontrado
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-field form-field-btn">
                    <label>&nbsp;</label>
                    <button id="btn-adicionar"
                            class="btn primary"
                            (click)="adicionarRegra()"
                            [disabled]="!cabecalhoPreenchido() || !novaRegra().tipo || (novaRegra().tipo !== 'FIXA' && (novaRegra().valorRefInicial === null || novaRegra().valorRefInicial === '')) || (novaRegra().valorComissao === null || novaRegra().valorComissao === '')">
                        + Adicionar
                    </button>
                </div>

            </div>
        </div>

        <div class="card" *ngIf="regras().length > 0">

            <div class="card-title">Parâmetros Cadastrados</div>

            <div class="table-container">
                <table>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Tipo</th>
                        <th>Valor Ref Inicial</th>
                        <th>Valor Ref Final</th>
                        <th>Comissão</th>
                        <th>Grupos</th>
                        <th>Descrição</th>
                        <th style="width:80px; text-align:center;" *ngIf="indiceEdicao() < 0">Ação</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let regra of regras(); let idx = index">
                        <td class="td-index">{{idx + 1}}</td>
                        <td>
                                <span class="badge-tipo" [ngClass]="badgeClass(regra.tipo)">
                                    {{labelTipo(regra.tipo)}}
                                </span>
                        </td>
                        <td class="td-valor">
                            <strong>{{regra.unidadeRef}} {{formatarDinheiro(regra.valorRefInicial)}}</strong>
                        </td>
                        <td class="td-valor">
                            <strong>{{regra.unidadeRef}} {{formatarDinheiro(regra.valorRefFinal)}}</strong>
                        </td>
                        <td class="td-valor td-comissao">
                            <strong>{{regra.unidadeComissao}} {{formatarDinheiro(regra.valorComissao)}}</strong>
                        </td>
                        <td class="td-grupos">
                            <div class="grupos-truncate" [title]="regra.todosGrupos ? 'Todos os grupos' : tooltipParamGrupos(regra)">
                                <span *ngIf="regra.todosGrupos" class="badge-grupo badge-todos">Todos</span>
                                <ng-container *ngIf="!regra.todosGrupos">
                                    <span *ngFor="let g of regra.grupos" class="badge-grupo">{{g.descricao}}</span>
                                </ng-container>
                            </div>
                        </td>
                        <td class="td-descricao">{{descrRegra(regra)}}</td>
                        <td style="text-align:center;" *ngIf="indiceEdicao() < 0">
                            <div class="action-menu-wrapper" (click)="$event.stopPropagation()">
                                <button class="btn-action-trigger"
                                        [ngClass]="{'open': actionMenuParamAberto() === idx}"
                                        (click)="toggleActionMenuParam(idx, $event)"
                                        title="Ações">⋮</button>
                                <div class="action-menu-dropdown" *ngIf="actionMenuParamAberto() === idx">
                                    <div class="action-menu-item" (click)="editarParametro(idx); fecharDropdowns()">Editar</div>
                                    <div class="action-menu-item" (click)="duplicarParametro(idx); fecharDropdowns()">Duplicar</div>
                                    <div class="action-menu-divider"></div>
                                    <div class="action-menu-item text-danger" (click)="removerRegra(idx); fecharDropdowns()">Excluir</div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="btn-actions" style="margin-top:16px;">
                <button class="btn primary" (click)="salvarRegras()" [disabled]="salvando()">
                    {{indiceEdicao() >= 0 ? 'Salvar Vendedores/Datas' : 'Salvar Regra'}}
                </button>
                <button class="btn secondary" (click)="limparRegras()" *ngIf="indiceEdicao() < 0">
                    Limpar Tudo
                </button>
                <button class="btn secondary" (click)="irParaLista()">
                    ← Cancelar
                </button>
            </div>

        </div>

        <div class="card" *ngIf="regras().length === 0 && !carregando()">
            <div class="empty-state">
                <p>Nenhum parâmetro adicionado ainda. Use o formulário acima para adicionar.</p>
            </div>
        </div>

    </div>

</div>
</div>

<div class="modal-overlay" *ngIf="modalConflitoAberto()" [ngStyle]="{'z-index': 10001}">
    <div class="modal-box" style="max-width: 500px;">
        <div class="modal-header">
            ⚠️ Vendedores já vinculados
            <button class="btn-close" (click)="fecharModalConflito()">×</button>
        </div>

        <div class="modal-body">
            <p style="margin-bottom: 20px; line-height: 1.5; font-size: 14px;">
                {{mensagemConflito()}}
            </p>

            <div style="display: flex; flex-direction: column; gap: 10px;">
                <button class="btn primary" (click)="resolverConflito('MANTER')" style="justify-content: center;">
                    1. Incluir nesta regra e manter nas antigas
                </button>

                <button class="btn secondary" style="border-color: var(--danger); color: var(--danger); justify-content: center;" (click)="resolverConflito('SUBSTITUIR')">
                    2. Vincular apenas nesta regra (Desvincular das outras)
                </button>

                <button class="btn secondary" (click)="fecharModalConflito()" style="justify-content: center;">
                    3. Não vincular (Cancelar e voltar)
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-overlay" *ngIf="simuladorAberto()">
    <div class="modal-box" style="width: 800px;">
        <div class="modal-header">
            Simulador de Regras
            <button class="btn-close" (click)="fecharSimulador()">×</button>
        </div>

        <div class="modal-body">
            <div class="form-field" style="margin-bottom: 12px; display:flex; flex-direction: column;">
                <label>Selecione a Regra para Testar</label>
                <select [(ngModel)]="simulacao().indexRegra" (change)="aoSelecionarRegraSimulacao()" style="margin-top: 5px;">
                    <option value="">-- Escolha uma regra --</option>
                    <option *ngFor="let r of listaDeRegras(); let i = index" [value]="i">
                        {{r.cabecalho.nome}}
                    </option>
                </select>
            </div>

            <div class="simulador-grid" *ngIf="simulacao().indexRegra !== '' && simulacao().indexRegra !== undefined">
                <div class="form-field" style="display:flex; flex-direction: column;">
                    <label>Grupo do Produto</label>
                    <select [(ngModel)]="simulacao().codGrupo" (change)="simulacao().resultados = null" style="margin-top: 5px;">
                        <option value="">-- Todos ou Específico --</option>
                        <option *ngFor="let g of grupos()" [value]="g.codGrupo">
                            {{g.descricao}}
                        </option>
                    </select>
                </div>
                <div class="form-field" style="display:flex; flex-direction: column;">
                    <label>Valor da Venda</label>
                    <div class="input-prefix-wrapper" style="margin-top: 5px;">
                        <span class="input-prefix">R$</span>
                        <input type="text" appMoneyMask class="input-valor" [(ngModel)]="simulacao().valorVenda" placeholder="0,00">
                    </div>
                </div>
                <div class="form-field" style="display:flex; flex-direction: column;">
                    <label>Desconto Concedido</label>
                    <div class="input-prefix-wrapper" style="margin-top: 5px;">
                        <span class="input-prefix">%</span>
                        <input type="text" appMoneyMask class="input-valor" [(ngModel)]="simulacao().descontoVenda" placeholder="0,00">
                    </div>
                </div>
            </div>

            <div style="margin-top: 16px;" *ngIf="simulacao().indexRegra !== '' && simulacao().indexRegra !== undefined">
                <button class="btn primary" style="width: 100%; justify-content: center;" (click)="simularVenda()">
                    Calcular Simulação
                </button>
            </div>

            <div class="simulacao-resultados" *ngIf="simulacao().resultados">

                <div class="card-title">Regras e Parâmetros Alcançados</div>

                <div *ngIf="simulacao().resultados!.length === 0" class="empty-state" style="padding: 20px;">
                    Nenhuma regra ou parâmetro se aplica aos valores informados.
                </div>

                <div class="result-card" *ngFor="let res of simulacao().resultados" style="flex-direction: column; align-items: stretch; margin-bottom: 10px; background: #f8fafc; padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0;">
                    <div style="font-size: 13px; font-weight: bold; color: var(--text-main); margin-bottom: 8px;">
                        {{res.nomeRegra}}
                    </div>
                    <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px;">
                        <div class="result-param-info" style="display:flex; align-items: center; gap: 10px;">
                            <span class="badge-tipo" [ngClass]="badgeClass(res.param.tipo)">{{labelTipo(res.param.tipo)}}</span>
                            <span class="result-desc" style="font-size: 11px; color: var(--text-muted);">{{res.detalhe || descrRegra(res.param)}}</span>
                        </div>
                        <div class="result-calc" style="text-align: right;">
                            <div style="font-size: 11px; color: var(--text-muted);">Comissão:</div>
                            <div class="result-valor" style="font-weight: bold; color: #059669; font-size: 14px;">{{res.valorCalculado}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-overlay" *ngIf="alertaModal()" [ngStyle]="{'z-index': 10002}">
    <div class="modal-box">
        <div class="modal-header" [ngClass]="alertaTipo()">
            <span *ngIf="alertaTipo() === 'sucesso'">✔ Sucesso</span>
            <span *ngIf="alertaTipo() === 'erro'">❌ Erro</span>
            <span *ngIf="alertaTipo() === 'aviso'">⚠ Aviso</span>
        </div>
        <div class="modal-body">
            <p>{{alertaTexto()}}</p>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharAlerta()">
                OK
            </button>
        </div>
    </div>
</div>